import type { CSSProperties, ReactElement } from "react";
import { Eye } from "lucide-react";
import { palette, space, typography } from "@ux/tokens";
import { useCanEdit } from "@shell/auth/useCanEdit";

const bannerStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: space[2],
    padding: `${space[2]} ${space[4]}`,
    background: palette.accentBg,
    borderBottom: `1px solid ${palette.border}`,
    color: palette.fgMuted,
    fontSize: typography.size.xs,
    fontWeight: typography.weight.medium,
};

/**
 * Sticky banner shown to callers without the Editor role. Sits inside
 * the admin content area so it lands in both desktop and phone layouts
 * without modifying the shared AdminShell composition. The banner is
 * the user-facing signal that explains *why* save/delete/create
 * controls are missing elsewhere on the page.
 */
export function ViewOnlyBanner(): ReactElement | null {
    const canEdit = useCanEdit();
    if (canEdit) return null;
    return (
        <div role="status" aria-live="polite" style={bannerStyle}>
            <Eye size={14} aria-hidden="true" />
            <span>
                View only — editing requires the Office Editor role. Contact your
                administrator to request access.
            </span>
        </div>
    );
}
